<template>
  <div class="text-center">
    <v-snackbar v-model="showError"
                multi-line
                top
                color="#FF4C4C"
                :timeout="timeout">
      {{ errorMessage }}
      <v-btn  dark
              text
              @click="hideError()">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions} from 'vuex';
export default {
  name: 'ErrorNotifier',
  //props:['showError', 'message'],
  data: () => ({
    timeout:15000

  }),
  computed:{
    ...mapState(['showError','errorMessage'])
  },
  methods:{
    ...mapActions(['hideError'])
    //
  }
}
</script>
